<h4 style="margin-bottom: 2px">{{ data.tipo }}</h4>
<div mat-dialog-content style="display: flex" *ngIf="data">
  <form [formGroup]="contactoForm" style="display: flex; flex: 1">
    <div style="flex: 1">
      <mat-form-field appearance="outline" class="input-contactoForm">
        <mat-label>Nombre</mat-label>
        <input matInput matNativeControl type="text" formControlName="nombre" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-contactoForm">
        <mat-label>1º apellido</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="apellido1"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-contactoForm">
        <mat-label>2º apellido</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="apellido2"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-contactoForm">
        <mat-label>Email</mat-label>
        <input
          matInput
          matNativeControl
          type="email"
          maxlength="120"
          formControlName="email"
        />
        <small *ngIf="emailNoValidoC"> Formato email no válido </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="input-contactoForm">
        <mat-label>Teléfono</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          class="no-arrow"
          formControlName="telefono"
        />
      </mat-form-field>
    </div>
    <div style="flex: 1">
      <mat-form-field
        style="width: 100%"
        appearance="outline"
        class="input-contactoForm"
      >
        <mat-label>Cargo</mat-label>
        <mat-select matInput matNativeControl formControlName="cargo">
          <mat-option *ngFor="let cargo of cargosList" [value]="cargo.nombre">{{
            cargo.nombre
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div
        [ngClass]="rojo ? 'borde-rojo' : 'div-acciones'"
        style="
          margin: 0.25em 0;
          width: 100%;
          height: 210px;
          overflow-y: auto;
          padding: 8px;
        "
      >
        <mat-label>Acciones</mat-label>
        <div *ngIf="accionesList">
          <div *ngFor="let accion of accionesList">
            <mat-checkbox
              style="margin-left: 20px"
              [checked]="isAccionSelected(accion.Id)"
              (change)="seleccionChange(accion.Id)"
            >
              {{ accion.Nombre }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!--<mat-form-field appearance="outline" class="input-contactoForm">
                <mat-label>Acciones</mat-label>
                <mat-select matInput formControlName="acciones" multiple (selectionChange)="changeAcciones($event.value)">
                    <mat-select-trigger>
                        {{ contactoForm.get('acciones').value ? getAccionesCoincidentesText() : '' }}
                    </mat-select-trigger>                    
                    <mat-option *ngFor="let accion of accionesList" [value]="accion.Id">{{ accion.Nombre }}</mat-option>
                </mat-select>                          
            </mat-form-field>-->

      <!--<div style="width: 320px; height: 210px; overflow-y: auto; padding: 8px;">
                <mat-label>Acciones</mat-label>
                <div *ngFor="let accion of accionesList; let i = index">
                    <mat-form-field>
                        <input  matInput readonly="true" [value]="accion.Nombre" (click)="inputClicked($event)" style="cursor: default;">
                        <mat-checkbox [value]="accion.Id" matPrefix style="margin-right: 10px;" (change)="seleccionChange(accion.Id)"></mat-checkbox>
                    </mat-form-field>
                </div>
            </div>-->

      <div style="display: flex; flex-direction: column">
        <button mat-button class="btn-contactoForm" (click)="guardarContacto()">
          {{ data.tipo === "Editar" ? "Guardar" : "Crear" }}
        </button>
        <button
          *ngIf="data.tipo === 'Editar'"
          mat-button
          (click)="borrarContacto()"
          class="btn-contactoForm"
        >
          Eliminar
        </button>
        <button
          mat-button
          (click)="enviarCorreoPrueba()"
          class="btn-contactoForm"
        >
          Mandar correo de prueba
        </button>
        <button mat-button matDialogClose class="btn-contactoForm-cerrar">
          Cerrar
        </button>
      </div>
    </div>
  </form>
</div>
